<template>
    <div id="app" class="h100b">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'app',
        created () {    
            console.log('App.vue')
        }
    }
</script>